import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Tabs, Tab, Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import MotorMake from "../motor-make";
import MotorModel from "../motor-model";
import MotorVariantList from "../motor-variant/ListMotorVariant";

const MotorMMVList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tabValue = sessionStorage.getItem("motorActiveTab") || "make";
  const tabValues = ["make", "model", "variant"];

  const [value, setValue] = useState(tabValue);

  // Extract tabState from URL query
  const getTabFromQuery = () => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tabState");
    return tabParam === null ? "make" : tabParam;
  };

  useEffect(() => {
    setValue(getTabFromQuery());
  }, [location.search]);

  const handleTabChange = (_, newValue) => {
    setValue(newValue);
    sessionStorage.setItem("motorActiveTab", newValue);
    navigate(`?tabState=${newValue}`);
  };

  const renderComponent = () => {
    switch (value) {
      case "make":
        return <MotorMake tabState={value} />;
      case "model":
        return <MotorModel tabState={value}/>;
      case "variant":
        return <MotorVariantList tabState={value}/>;

      default:
        return null;
    }
  };

  return (
    <DashboardLayout>
      <Box sx={{ marginX: 1 }}>
        <Tabs
          value={value}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="secondary"
          aria-label="secondary tabs example"
        >
          {/* Render tabs based on tabValues */}
          {tabValues.map((tabValue) => (
            <Tab
              key={tabValue}
              value={tabValue}
              label={`Motor ${
                tabValue.charAt(0).toUpperCase() + tabValue.slice(1)
              }`}
              sx={{ fontWeight: value === tabValue ? "bold" : "normal" }}
            />
          ))}
        </Tabs>
      </Box>

      <Box>{renderComponent()}</Box>
    </DashboardLayout>
  );
};

export default MotorMMVList;
